import React, { useEffect, useState } from "react";
import aleData from "../../test/ale.json"; // Adjust path as needed
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useTranslation } from "react-i18next";
import FAIRModelVisualization from "../../../../components/charts/FairModel";
import { useSelector } from "react-redux";
import { getDashboardData } from "../../../../redux/actions/dashboardActionCreators";

export default function AleDetails() {
  const dashboardData = useSelector((state) => state.dashboard.jsonData);

  const aleData = dashboardData?.ale_values || [];

  const { t } = useTranslation();
  const history = useHistory();

  function handlGoBack() {
    history.goBack();
  }
  const [selectedThreat, setSelectedThreat] = useState("");

  const aleBaseDescription = "Select a threat to get description";

  const aleDisplayDescriptionValue = selectedThreat
    ? aleData.find((item) => item.threat === selectedThreat)?.[
        "justification"
      ] || ""
    : aleBaseDescription;

  const fairModelData = selectedThreat
    ? [aleData.find((item) => item.threat === selectedThreat)]
        .filter((item) => item) // Filter out undefined if threat not found
        .map((item) => ({
          mother: item["ale_mean"],
          child1: item["tlm_mean"],
          child2: item["lef_mean"],
        }))[0] || { mother: 0, child1: 0, child2: 0 } // Default if not found
    : aleData.reduce(
        (sum, item) => ({
          mother: sum.mother + item["ale_mean"],
          child1: sum.child1 + item["tlm_mean"],
          child2: sum.child2 + item["lef_mean"],
        }),
        { mother: 0, child1: 0, child2: 0 }
      ); // Initial accumulator

  const aleDisplayData = selectedThreat
    ? [aleData.find((item) => item.threat === selectedThreat)].map((item) => ({
        Threat: item.threat,
        "5th Percentile": item["5th Percentile"],
        Median: item["Median"],
        Mean: item["Mean"],
        "95th Percentile": item["95th Percentile"],
      }))
    : aleData.map((item) => ({
        Threat: item.threat,
        "5th Percentile": item["5th Percentile"],
        Median: item["Median"],
        Mean: item["Mean"],
        "95th Percentile": item["95th Percentile"],
      }));
  console.log(aleDisplayData);
  const handleChange = (event) => {
    setSelectedThreat(event.target.value);
  };

  return (
    <>
      <Box sx={{ marginBottom: { xs: "25%" } }}>
        <Button
          sx={{
            background: "#78c3ae",
            borderRadius: 4,
            fontSize: "16px",
            marginLeft: { xs: "8px", sm: "5px" }, // Remove marginLeft on mobile
            alignSelf: "flex-start",

            "&:hover": {
              backgroundColor: "#60dbb9",
            },
          }}
          onClick={handlGoBack}
        >
          <ArrowBackIcon sx={{ color: "white" }} />
        </Button>
        <Typography sx={{ textAlign: "center", fontSize: "40px" }}>
          Projected Annual Loss By Threat Type
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "stretch",
            maxWidth: "100%",
            margin: "auto",
            mt: { xs: 2, sm: 2 },
            px: { xs: 1, sm: 2 },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              flexWrap: "wrap",
              gap: { xs: 2, sm: 2 },
              flex: 1,
              width: "100%",
            }}
          >
            {/* Box 1: Threat selection */}
            <Box
              sx={{
                boxShadow: 3,
                borderRadius: 2,
                p: { xs: 2, sm: 3 },
                bgcolor: "background.paper",
                width: {
                  xs: "90%",
                  sm: "calc(25% - 16px)",
                  md: "calc(20% - 32px)",
                },
                flex: 1,
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                minHeight: 180,
              }}
            >
              <FormControl fullWidth>
                <InputLabel
                  id="threat-select-label"
                  sx={{ fontSize: { xs: "1rem", sm: "1.2rem" } }}
                >
                  Threat Type
                </InputLabel>
                <Select
                  labelId="threat-select-label"
                  id="threat-select"
                  value={selectedThreat}
                  label="Threat Type"
                  onChange={handleChange}
                  sx={{
                    height: { xs: "52px", sm: "64px" },
                    fontSize: { xs: "1rem", sm: "1.25rem" },
                  }}
                >
                  <MenuItem
                    value=""
                    sx={{ fontSize: { xs: "0.9rem", sm: "1.1rem" } }}
                  >
                    <em>All threats</em>
                  </MenuItem>
                  {aleData.map((threat, index) => (
                    <MenuItem
                      key={index}
                      value={threat.threat}
                      sx={{ fontSize: { xs: "0.9rem", sm: "1.1rem" } }}
                    >
                      {t(threat.threat)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "center",
            alignItems: "flex-start",
            gap: { xs: 2, sm: 4 },
            mt: 4,
            px: { xs: 1, sm: 2 },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "flex-start",
              width: "90%",
              gap: { xs: 2, sm: 4 },
              mt: 1,
              px: { xs: 1, sm: 2 },
            }}
          >
            <Box
              sx={{
                boxShadow: 2,
                borderRadius: 2,
                p: 2,
                bgcolor: "background.paper",
                width: "90%",
                minHeight: "300px",
                height: "auto",
                textAlign: "center",
              }}
            >
              <FAIRModelVisualization data={fairModelData} />
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "center",
            alignItems: "flex-start",

            gap: { xs: 2, sm: 4 },
            mt: 4,
            px: { xs: 1, sm: 2 },
          }}
        >
          {/* Description Box */}
          <Box
            sx={{
              boxShadow: 3,
              borderRadius: 2,
              p: { xs: 2, sm: 3 },
              bgcolor: "background.paper",
              width: { xs: "90%", sm: "90%", md: "90%" },
              minHeight: "450px",
              height: "auto",
              textAlign: "start",
            }}
          >
            <Typography>{aleDisplayDescriptionValue}</Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
}
